/**
 * General Settings Component
 *
 * Displays general message settings for the free shipping bar.
 * Single Responsibility: Render general settings section
 */
import { Paper, Stack, Title, Text, TextInput, Divider, Alert, Anchor, Switch } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';

export const GeneralSettings = ({ settings, onSettingsChange }) => {
  return (
    <Paper shadow="sm" p="xl" radius="md" withBorder>
      <Stack gap="lg">
        <div>
          <Title order={3} mb="xs">General Settings</Title>
          <Text size="sm" c="dimmed">
            Configure the messages shown to customers
          </Text>
        </div>

        <Divider />

        <TextInput
          label="Initial Message"
          description="Shown when customer hasn't reached the threshold. Use {amount} for remaining amount."
          placeholder="Add {amount} more to get free shipping!"
          value={settings.message_initial}
          onChange={(event) => onSettingsChange({ ...settings, message_initial: event.currentTarget.value })}
        />

        <Switch
          label="Hide bar when customer qualifies"
          description="If enabled, the bar will be hidden once customer reaches free shipping threshold"
          checked={settings.hide_when_qualified}
          onChange={(event) => onSettingsChange({ ...settings, hide_when_qualified: event.currentTarget.checked })}
        />

        {!settings.hide_when_qualified && (
          <TextInput
            label="Qualified Message"
            description="Shown when customer qualifies for free shipping"
            placeholder="You qualify for free shipping!"
            value={settings.message_qualified}
            onChange={(event) => onSettingsChange({ ...settings, message_qualified: event.currentTarget.value })}
          />
        )}

        <Alert variant="light" color="blue" title="Free Shipping Threshold" icon={<IconInfoCircle />}>
          The free shipping threshold is automatically retrieved from your WooCommerce shipping settings.{' '}
          <Anchor href="https://woocommerce.com/document/free-shipping/" target="_blank" rel="noopener noreferrer">
            Learn how to configure free shipping in WooCommerce
          </Anchor>
        </Alert>
      </Stack>
    </Paper>
  );
};
